import { ObservableStorage } from './observable-storage';
import { OAuthTokenResponse } from "../models/auth";

export class TokenStorage extends ObservableStorage<OAuthTokenResponse> {
	constructor() {
		super('token', localStorage);
	}
}
